module.exports = __webpack_public_path__ + "static/media/Table2.2510c995.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Table2.jpg
// module id = 150
// module chunks = 0